import React from 'react';
import { Card, Col, Row, Space, Typography } from 'antd';

import './styles.css';
import { CampaignRequestorKpiTable } from './CampaignRequestorKpiTable';

const { Text } = Typography;

const CampaignRequestorReviewAttribution = ({ form, formValues }) => {
  // Support both reactive system and old form system
  const values = formValues || {};
  const awarenessCampaign = formValues ? values.awarenessCampaign : form?.getFieldValue('awarenessCampaign');

  // Check if there are any measurement configurations
  const hasTransactions = formValues?.transactionsConfig;
  const hasSignUps = formValues?.signUpConfig;
  const hasSessions = formValues?.sessionConfig;
  const hasMeasurements = hasTransactions || hasSignUps || hasSessions;

  // Show KPI table only if it's not an awareness-only campaign OR if there are actual measurements configured
  const showKpiTable = !awarenessCampaign || hasMeasurements;

  return (
    <Card title="ATTRIBUTION REPORTING">
      <Space direction="vertical" size="middle" style={{ width: '100%' }}>
        <Row gutter={20}>
          <Col span={6}>
            <Space direction="vertical" size="small" style={{ width: '100%' }}>
              <Text type="secondary">Awareness Campaign</Text>
              <Text>{awarenessCampaign ? 'Yes' : 'No'}</Text>
            </Space>
          </Col>
        </Row>

        {showKpiTable && (
          <CampaignRequestorKpiTable
            form={form}
            editable={false}
            transactionsConfig={formValues?.transactionsConfig}
            signUpConfig={formValues?.signUpConfig}
            sessionConfig={formValues?.sessionConfig}
            awarenessCampaign={awarenessCampaign}
          />
        )}
        {/* <CampaignRequestorWalkInTable form={form} /> */}
      </Space>
    </Card>
  );
};

export default CampaignRequestorReviewAttribution;
